import Services from "../../../jsx/components/Dashboard/Services/services";

const ServicesWrapper = () => {
  return <Services />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(ServicesWrapper);
